<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <rect x="0.5" y="0.5" width="17" height="17" rx="5.5" stroke="#7019FD" />
    </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 18,
    },
    width: {
        ...iconProps.width,
        default: 18,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 18 18",
    }
  },
}
</script>